import { useJsonLd } from './useJsonLd'
import { useLocaleUrl } from './useCanonical'
import { SITE_URL } from './useSeo'

export function useBlogSeo(post: {
  title: string
  description: string
  date: string
  author: string
  slug: string
  updated?: string
  ogImage?: string
}) {
  const pageUrl = useLocaleUrl()

  useJsonLd({
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: post.title,
    description: post.description,
    datePublished: post.date,
    // Signals a substantive edit; without it a corrected post keeps its
    // original date and looks stale to crawlers.
    ...(post.updated ? { dateModified: post.updated } : {}),
    author: {
      '@type': 'Person',
      name: post.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'IT-Service Harting',
      url: SITE_URL
    },
    mainEntityOfPage: pageUrl(`/blog/${post.slug}`),
    image: post.ogImage || `${SITE_URL}/media/og-default.png`
  })
}
